
import { Box, Button, MenuItem, TextField } from '@mui/material'
import { BoxFC, BoxFR } from 'components/BoxCustom'
import ComboBox from 'components/ComboBox'
import DataGridCellExpand from 'components/DataGridCellExpand/DataGridCellExpand'
import React, { useCallback, useState, useContext, useEffect } from 'react'
import { GlobalStateContext } from 'contexts/GlobalStateContext'
import SearchButton from 'components/buttons/SearchButton'
import ClearButton from 'components/buttons/ClearButton'
import { initTransactionFilterData, clearTransactionFilterData } from './initData'
import { addIdForDataGrid } from 'utils'
import { sparePartApiNm, sparePartTransactionColNm } from './constant'
import AddButton from 'components/buttons/AddButton'
import SparePartTransactionDialog from './SparePartTransactionDialog'
import SparePartManagementDialog from './SparePartManagementDialog'
import { sparePartTransactionColumns } from './columns'
import DateTimeSelect from 'components/DateTimeSelect'
import ConstructionIcon from '@mui/icons-material/Construction';
import { sparePartColNm } from '../SparePartManagement/constant'

let selectedId = null
let lastFilter = null

const SparePartTransaction = () => {
  const { ax, msData } = useContext(GlobalStateContext)
  const [dataTable, setDataTable] = useState([])
  const [dialogOpen, setDialogOpen] = useState(false)
  const [mgmtDialogOpen, setMgmtDialogOpen] = useState(false)
  const [filterData, setFilterData] = useState({ ...initTransactionFilterData })
  const [sparePartCombo, setSparePartCombo] = useState([])

  const getData = useCallback((filter) => {
    ax.post(sparePartApiNm.getSparePartTransaction, filter).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, 'SpTrnsId'))
        lastFilter = filter
      }
    })
  }, [ax])

  const handleCellClick = useCallback((params) => {
    if (params.field === 'ShowDetail') {
      selectedId = params.id
      setDialogOpen(true)
    }
  }, [])

  const handleRowDoubleClick = useCallback((params) => {
    selectedId = params.id
    setDialogOpen(true)
  }, [])

  const onFinish = useCallback((data) => {
    getData(lastFilter)
  }, [getData])

  const handleAdd = useCallback(() => {
    selectedId = null
    setDialogOpen(true)
  }, [])

  const loadSparePartCombo = useCallback(() => {
    ax.post(sparePartApiNm.getSparePart, { IsActv: 1 }).then(value => {
      if (value.data) {
        setSparePartCombo(value.data.map(item => ({ id: item.SpId, label: `${item.SpCd ? item.SpCd + ' - ' : ''}${item.SpNm}`, Unt: item.Unt, UntPr: item.UntPr, CurStk: item.CurStk })))
      }
    })
  }, [ax])

  useEffect(() => {
    getData({ ...initTransactionFilterData })
    loadSparePartCombo()
  }, [getData, ax, loadSparePartCombo])

  return (
    <BoxFC height='100%'>
      <BoxFR>
        <AddButton onClick={handleAdd}>เพิ่มรายการ</AddButton>
        <Button variant="contained" onClick={() => setMgmtDialogOpen(true)}> <ConstructionIcon sx={{ mr: 1 }} /> การจัดการอะไหล่</Button>
        <Box flex={1} />
        <ComboBox
          options={sparePartCombo}
          label="อะไหล่"
          selectedId={filterData.SpId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, SpId: id }))}
          sx={{ width: 200 }}
        />
        <ComboBox
          options={msData.truckCombo || []}
          label={sparePartTransactionColNm.TukId}
          selectedId={filterData.TukId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, TukId: id }))}
          sx={{ width: 150 }}
        />
        <ComboBox
          options={msData.supplierCombo || []}
          label={sparePartTransactionColNm.SupId}
          selectedId={filterData.SupId}
          setSelectedId={(id) => setFilterData(o => ({ ...o, SupId: id }))}
          sx={{ width: 150 }}
        />
        <TextField size="small" label={sparePartTransactionColNm.TrnsTyp} select sx={{ width: 100 }}
          value={filterData.TrnsTyp ?? ""}
          onChange={(e) => setFilterData(o => ({ ...o, TrnsTyp: e.target.value || null }))}>
          <MenuItem value="">ทั้งหมด</MenuItem>
          <MenuItem value="I">รับเข้า</MenuItem>
          <MenuItem value="O">เบิกออก</MenuItem>
        </TextField>
        <DateTimeSelect
          label={sparePartColNm.TrnsDte}
          start={filterData.TrnsDteSt}
          end={filterData.TrnsDteEn}
          setSelectDate={(st, en) => setFilterData(o => ({ ...o, TrnsDteSt: st, TrnsDteEn: en }))}
          sx={{ width: 150 }}
          initRadioValue="MONTH"
        />
        <SearchButton onClick={() => getData(filterData)} />
        <ClearButton onClick={() => setFilterData({ ...clearTransactionFilterData })} />
      </BoxFR>
      <Box height='100%'>
        <DataGridCellExpand
          hideFooter
          rows={dataTable}
          columns={sparePartTransactionColumns}
          onRowDoubleClick={handleRowDoubleClick}
          onCellClick={handleCellClick}
        />
      </Box>
      <SparePartManagementDialog
        dialogOpen={mgmtDialogOpen}
        setDialogOpen={setMgmtDialogOpen}
        onFinish={loadSparePartCombo}
      />
      <SparePartTransactionDialog
        selectedId={selectedId}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        onFinish={onFinish}
        lastFilter={lastFilter}
      />
    </BoxFC>
  )
}

export default SparePartTransaction
